module.exports = __webpack_public_path__ + "assets/CutRectangleDetailed.5f1c47579798974bead1489abdc28a8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CutRectangleDetailed.png
// module id = 500
// module chunks = 0